import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import type Coupon from '@alltrails/types/Coupon';
import styles from './CheckoutModalFooter.module.scss';
import StripeApplePayButton from './StripeApplePayButton';
import StripeCheckoutSubmitButton from './StripeCheckoutSubmitButton';
import StripePayPalButton from './StripePayPalButton';

type Props = {
  coupon?: Coupon;
  isRadioUiEnabled?: boolean;
  selectedPaymentType?: string;
  submitting: boolean;
};

export default function StripeCheckoutModalFooter({ coupon, isRadioUiEnabled, selectedPaymentType, submitting }: Props) {
  const [canScrollDown, setCanScrollDown] = useState(false);

  const checkScrollPosition = () => {
    const container = document.querySelector('#modal-scroll-container');
    if (container) {
      const { scrollTop, scrollHeight, clientHeight } = container;
      setCanScrollDown(clientHeight + scrollTop + 1 < scrollHeight); // + 1 to deal with decimals at misc screen heights
    }
  };

  useEffect(() => {
    const container = document.querySelector('#modal-scroll-container');
    if (container) {
      container.addEventListener('scroll', checkScrollPosition);
      checkScrollPosition();
    }
    return () => {
      if (container) {
        container.removeEventListener('scroll', checkScrollPosition);
      }
    };
  }, []);

  return (
    <div className={classNames(styles.footer, { [styles.canScrollDown]: canScrollDown })}>
      <div className={styles.footerContent}>
        {isRadioUiEnabled && selectedPaymentType === process.env.NEXT_PUBLIC_STRIPE_PAYPAL_CUSTOM_PAYMENT_METHOD && (
          <StripePayPalButton submitting={submitting} />
        )}
        {isRadioUiEnabled && selectedPaymentType === 'apple_pay' && <StripeApplePayButton submitting={submitting} />}
        {(!isRadioUiEnabled ||
          (selectedPaymentType !== process.env.NEXT_PUBLIC_STRIPE_PAYPAL_CUSTOM_PAYMENT_METHOD && selectedPaymentType !== 'apple_pay')) && (
          <StripeCheckoutSubmitButton coupon={coupon} submitting={submitting} />
        )}
      </div>
      <div className={styles.caption}>
        <FormattedMessage defaultMessage="Cancel anytime in settings" />
      </div>
    </div>
  );
}
